<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">
            {{ course.name }}
            - {{ course.distance }}
          </h2>
          <h4>{{ course.date }} - Départ 20h00</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <!-- <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div> -->
          <p>Run by night 4ème édition au Domaine de Cabasse à Miramas</p>
          <p>Munissez-vous de votre lampe frontale et venez vivre une aventure sportive et festive lors d'un trail nocturne sur un site naturel d'exception composé de 3 parcours balisés et sécurisés.</p>
          <p>3 parkings à disposition - Buvette, restauration et animations sur place</p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/runbynight.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : 07.64.77.06.72</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/rbn_maritima.jpg" target="_blank">Tracé de l'épreuve</b-button>
          <b-button class="infos_btn" href="https://sportips.fr/RBN23/" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="https://sportips.fr/RBN23/" target="_blank">Réglement</b-button>

          <b-button class="infos_btn" href="https://sportips.fr/RBN23/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>